"use client";
import React from "react";
import Footer from "../components/Footer";
import YourFreedom from "../components/pricing/YourFreedom";
import AccountsNTransfers from "../components/pricing/AccountsNTransfers";
import HeadingWithChips from "../components/common/HeadingWithChips";
import FirstSection from "../components/common/FirstSection";
import randomGraphic from '../assets/random-graphic.png';
import cylinder from '../assets/nohiddenfees/image.png'

const Pricing: React.FC = () => {
  return (
        <main>
        <FirstSection 
        icon={cylinder}
        iconAlt="Suite icon"
        backgroundImage={randomGraphic}
        title="No hidden fees, <br/>
              no surprises"
        description={
            <>
                With EPAYR you know exactly <br/>
                what you’re paying for
            </>
        }
        buttonText="CONTACT US"
        buttonVariant="lightPurple"
        buttonHref="/contact"
        leftColumnSx={{
            backgroundColor: "beige.200"
        }}
        heading="simple <br/>
              and transparent <br/> pricing for you"
        />
        <AccountsNTransfers/>
        <YourFreedom/>
        <HeadingWithChips 
              headingPrefix="Do you still have"
              headingHighlight=" questions "
              headingSuffix="about pricing?"
              subheading=''
              discussionText={["", " SUBMIT YOUR ", " AND ONE OF THE EPAYR TEAM MEMBERS WILL REPLY "]}
              chips = {[
                { text: "LET'S CHAT.", backgroundColor: "lime.100", textColor: "lightPurple.500" },
                { text: "REQUEST",  backgroundColor: "beige.200",  textColor: "beige.700" },
                { text: "SHORTLY.", backgroundColor: "lightPurple.200", textColor: "lightPurple.500" },
              ]}
              displayIcons={false}
              showButton={true}
              buttonVariant="lime"
              buttonText="CONTACT US"
            />
        <Footer 
              buttonText="LET'S START" 
              buttonLink="/individuals"
              ctaText={{
                prefix: 'LEARN HOW TO OPEN <br/> A',
                highlight1: ' PERSONAL',
                middle: ' ACCOUNT',
                highlight2: '',
                suffix: ''
              }}
            />
        </main>
  );
};

export default Pricing;
